import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapSinglRowColCard = React.lazy(function () {
    return import('../../bootstrap-components/components/BTSingleRowColCard');
});
var bootStrapButton = function (props) {
    return (React.createElement(BootStrapSinglRowColCard, __assign({}, props)));
};
var SinglRowColCard = function (props) {
    var componentToDisplay = bootStrapButton(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapButton(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
SinglRowColCard.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default SinglRowColCard;
//# sourceMappingURL=SingleRowColCard.js.map